export default {
  'menu.result.error': 'Error',
  'error.result.title': 'Submit Error',
  'error.result.subTitle': 'Submit form error',
  'error.result.goBack': 'Go Back',
  'error.result.retry': 'return for correction',
  'error.detailTitle': 'Details of Error',
  'error.detailLine.record':
    'The current domain name has not been registered, please check the registration process: ',
  'error.detailLine.record.link': 'Registration Process',
  'error.detailLine.auth':
    'Your user group does not have the authority to perform this operation;',
};
